<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- <div class="tab-wrap">
      <el-tabs v-model="page.listType" @tab-click="filterFlow">
        <el-tab-pane label="全部流程" name="0"> </el-tab-pane>
        <el-tab-pane label="待处理" name="4"></el-tab-pane>
        <el-tab-pane label="已处理" name="2"></el-tab-pane>
        <el-tab-pane label="我收到的" name="3"></el-tab-pane>
        <el-tab-pane label="我发起的" name="1"></el-tab-pane>
      </el-tabs>
    </div> -->
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div">合同名称：</div>
          <el-input size="mini" v-model="page.contractName" class="ipt-sty" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">甲方名称：</div>
          <el-select size="mini" filterable clearable v-model="page.tenantGuid" class="ipt-sty" placeholder="请选择">
            <el-option
              v-for="item in tenantList"
              :key="item.guid"
              :label="item.tenantName"  
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">乙方名称：</div>
          <el-select size="mini" filterable clearable v-model="page.serviceTenantGuid" class="ipt-sty" placeholder="请选择">
            <el-option v-for="item in serviceTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button
            size="mini"
            type="text"
            @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getList(1)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button></el-col
        >
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6"
          ><div class="search-area-div">提交人：</div>
          <el-input size="mini" v-model="page.staffName" clearable class="ipt-sty" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">项目经理：</div>
          <el-input size="mini" v-model="page.projectManagerName" clearable class="ipt-sty" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">盖章合同：</div>
          <el-select size="mini" filterable clearable v-model="page.isUploadContract" class="ipt-sty" placeholder="请选择">
            <el-option v-for="item in yesOrNo" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <!-- <el-col  :span="6"
          ><el-button size="mini" type="info" @click="getList(1)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button></el-col
        > -->
      </el-row>
    </div>

    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <!-- <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addContract">新建合同</el-button>
      </div> -->
      <el-table :data="tableData" stripe border style="width: 100%" v-loading="tableLoading" :height="tableHeight">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
   

        <el-table-column
          prop="tenantName"
          label="甲方名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="210"
          fixed="left"
        >
          <template slot-scope="scope">{{ scope.row.tenantName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="serviceTenantName"
          label="乙方名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="210"
          fixed="left"
        >
          <template slot-scope="scope">{{ scope.row.serviceTenantName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="endTime" label="审批状态" header-align="center" align="center" width="80">
          <template slot-scope="scope">
            <a class="reject-btn btn" v-if="scope.row.approveState == 'R'">已驳回</a>
            <a class="pass-btn btn" v-if="scope.row.approveState == 'Y'">已通过</a>
            <a class="ing-btn btn" v-if="scope.row.approveState == 'A'">审批中</a>
            <a class="cancel-btn btn" v-if="scope.row.approveState == 'N'">草稿中</a>
            <a class="cancel-btn btn" v-if="scope.row.approveState == 'C'">已撤销</a>
          </template>
        </el-table-column>
        <el-table-column prop="contractYear" label="提交人" header-align="center" align="left" width="100">
          <template slot-scope="scope">{{ scope.row.createUserName }}</template>
        </el-table-column>
        <el-table-column prop="projectManagerName" label="运营经理" header-align="center" align="left" width="100">
          <template slot-scope="scope">{{ scope.row.projectManagerName||'-' }}</template>
        </el-table-column>
        <el-table-column
          prop="signDate"
          label="签约时间"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="100"
        >
          <template slot-scope="scope">{{ scope.row.signDate | getDate }}</template>
        </el-table-column>
        <el-table-column
          prop="validityDate"
          label="合同有效期"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope"
            ><span
              :style="{
                color:
                  !scope.row.validityDate ||
                  new Date().getTime() <= new Date(scope.row.validityDate).getTime() + 86400000
                    ? ''
                    : 'red',
              }"
              >{{ scope.row.validityDate | getDate }}</span
            ></template
          >
        </el-table-column>
        <el-table-column
          prop="contractType"
          label="盖章合同"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.isUploadContract=='Y'?'已上传':'未上传'}}</template>
        </el-table-column>
        <el-table-column
          prop="contractType"
          label="合同类型"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.contractType | commonFilterName('合同类型') }}</template>
        </el-table-column>
        <el-table-column
          prop="contractContent"
          label="业务类型"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.contractContentType == '1' ? '业务收入' : '业务支出' }}</template>
        </el-table-column>
        <el-table-column
          prop="contractContent"
          label="业务类型内容"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">
            {{
              scope.row.contractContent
                | commonFilterName(scope.row.contractContentType == '1' ? '业务收入类型' : '业务支出类型')
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="contractMoney"
          label="合同金额"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="110"
        >
          <template slot-scope="scope">{{ scope.row.contractMoney | numDigit }}</template>
        </el-table-column>
        <el-table-column
          prop="contractName"
          label="合同名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.contractName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="contractCode"
          label="合同编码"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.contractCode || '-' }}</template>
        </el-table-column>
        <el-table-column prop="startTime" label="操作时间" header-align="center" align="left" width="140">
          <template slot-scope="scope">{{ scope.row.updateTime | getTime }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="120" label="操作" fixed="right" header-align="center" align="center">
          <template slot-scope="scope">
            <a
              class="txt-color"
              v-if="getListBtnState('detail', scope.row) == 'detail'"
              @click="editContract(scope.row, 2)"
            >
              详情
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100, 200]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
    <el-dialog title="上传盖章合同" :visible.sync="uploadFileDialogVisible" width="500px" top="15%">
      <el-row :gutter="24" class="file-box">
        <template v-if="form.isMail=='Y'">
        <el-col :span="24"
          ><div class="search-area-div"><span class="fontC-red">*</span>快递公司：</div>
          <el-input v-model="fileForm.expressCompany" class="ipt-sty" placeholder="请输入" maxlength="30" clearable></el-input>
        </el-col>
        <el-col :span="24"
          ><div class="search-area-div"><span class="fontC-red">*</span>快递单号：</div>
          <el-input v-model="fileForm.expressNo" class="ipt-sty" placeholder="请输入" maxlength="30" clearable></el-input>
        </el-col>
        </template>

        <el-col :span="24"><div class="search-area-div"><span class="fontC-red">*</span>上传合同盖章附件：</div>
          <el-upload
            class="upload-demo t-left"
            action="#"
            multiple
            :limit="1"
            accept=".pdf,.docx,.doc"
            :on-exceed="handleExceed"
            :on-remove="handleFileRemove"
            :http-request="uploadFile"
            :file-list="fileList"
            :beforeUpload="beforeAvatarUpload"
          >
            <el-button size="mini" icon="el-icon-my-import" style="margin-top: 8px; margin-bottom: 0" type="importNew"
              >导入文件</el-button
            >
            <div slot="tip" class="el-upload__tip">支持.pdf,.docx,.doc文件，单个文件不得大于20M</div>
          </el-upload>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="fileSubmit()">提交</el-button>
      </span>
    </el-dialog>
    <ChoosePerson ref="choosePerson" :staffType="staffType" @onSelect="onPersonSelect"></ChoosePerson>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import workFlowCommon from '@/uilt/workFlowCommon';
import ChoosePerson from '@/components/person/choosePerson';
export default {
  components: {
    ChoosePerson,
  },
  data() {
    return {
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      staffType: 1,
      tableHeight: window.innerHeight - 230,
      contentMainHeight: window.innerHeight - 130,
      flowType: '00010',
      fullscreenLoading: false,
      currentStaffGuid: null,
      tenantList: [], //甲方
      serviceTenantList: [], //乙方
      page: {
    
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '', //甲方
        serviceTenantGuid: '', //乙方
        staffGuid: '',
        contractName: '',
        approveState: null,
        currentTenantGuid:localStorage.guid,
        // listType: "0",
        isUploadContract:null,
        projectManagerName:''
      },
      yesOrNo: [
        { label: '全部', value: null },
        { label: '已上传', value: 'Y' },
        { label: '未上传', value: 'N' },
      ],
      approveStateOption: [
        { label: '全部', value: null },
        { label: '草稿中', value: 'N' },
        { label: '审批中', value: 'A' },
        { label: '已通过', value: 'Y' },
        { label: '已驳回', value: 'R' },
        { label: '已撤销', value: 'C' },
      ],
      fileForm: {
        contractGuid: null,
        expressNo: null,
        expressCompany: null,
        electronicContractFileList: [],
      },
      tableLoading: false,
      tableData: [],
     
      right: 'right',
      approveSuggest: '',
      passDialogVisible: false,
      rejectDialogVisible: false,
      form: '',
      // 上传盖章合同
      uploadFileDialogVisible: false,
      //上传附件
      fileUrl: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      fileList: [], //上传文件列表
    };
  },

  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.currentStaffGuid = userinfo.staffGuid;
    this.getList(1);
    this.getTenantList();
    this.getServiceTenantList();
  },
  activated(){
    this.getList();
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 280;
        this.contentMainHeight = window.innerHeight - 180;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 230;
        this.contentMainHeight = window.innerHeight - 130;
        return;
      }
    
    },
  },
  methods: {
    filterFlow(){
      this.getList();
    },
    //获取操作按钮显隐
    getListBtnState(btnType, row) {
      return workFlowCommon.getListBtnState(
        btnType,
        row.approveState,
        row.staffGuid,
        row.approveStaffGuids,
        this.currentStaffGuid,
        row.bizApproveState,
      );
    },
    //获取审批状态
    getStateShow(approvalState) {
      return workFlowCommon.getStateClass(approvalState);
    },
    //新增
    addContract() {
      this.$router.push('/contractInformationAdd?productGuid='+this.$route.query.productGuid);
    },
    //获取客户
    getTenantList() {
      let self = this;
      let query = {
        memberStatus: "ZSHY",
        pageIndex: 1,
        pageSize: -1,
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取乙方
    getServiceTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['9901', '9903', '9904'],
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.serviceTenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    choosePerson(obj) {
      this.form = obj;
      this.$refs.choosePerson.open(this.form.projectManagerGuid ? [this.form.projectManagerGuid] : []);
    },
    //指定运营经理
    onPersonSelect([personGuid, data, name]) {
      this.form.projectManagerGuid = personGuid && personGuid.length > 0 ? personGuid[0] : null;
      this.form.projectManagerName = name || null;
      if (!this.form.projectManagerGuid) return;
      this.fullscreenLoading = true;
      let req = {
        guid: this.form.guid,
        projectManagerName: this.form.projectManagerName,
        projectManagerGuid: this.form.projectManagerGuid,
        isAssignProjectManager:'Y',
        tenantGuid:this.form.tenantGuid,//甲方
        serviceTenantGuid:this.form.serviceTenantGuid,//乙方

      };
      this.api.postJson(`/${serverConfig.msCustomerService}/contract/save`, req).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message({
            message: '指定成功',
            type: 'success',
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getCcShow(row){
      let userInfo = JSON.parse(localStorage.userInfo);
      let ccGuids = row.ccGuids;
      let flg = ccGuids && ccGuids.indexOf(userInfo.staffGuid) > -1 ? true : false;
      return flg
    },
    //上传盖章合同
    uploadFileDialog(row) {
      this.form = row;
      this.uploadFileDialogVisible = true;
      this.fileForm = {
        contractGuid: row.guid,
        expressNo: null,
        expressCompany: null,
        electronicContractFileList: [],
      }
      this.fileList = [];
    },
    fileSubmit(){
      if(!this.fileForm.expressNo&&this.form.isMail=='Y'){
        this.$message.error('快递公司不能为空！');
        return
      }
      if(!this.fileForm.expressCompany&&this.form.isMail=='Y'){
        this.$message.error('快递单号不能为空！');
        return
      }
      if(!this.fileList.length){
        this.$message.error('上传合同盖章附件不能为空！');
        return
      }
      this.fileForm.electronicContractFileList = [];
      this.fileList.forEach(i=>{
        let obj = {
          fileName:i.name,
          path:i.path
        }
        this.fileForm.electronicContractFileList.push(obj);
      })
      let userInfo=JSON.parse(localStorage.userInfo);
      let query={
        ...this.fileForm,
        currentStaffGuid:userInfo.staffGuid
      }
      this.api.postJson(`/${serverConfig.msCustomerService}/contract/save-approve-contract-end-info`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.uploadFileDialogVisible = false;
          this.$message({
            message: '提交成功',
            type: 'success',
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //清空
    emptySearch() {
      this.page = {
        // listType: "0",
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '', //甲方
        serviceTenantGuid: '', //乙方
        staffGuid: '',
        contractName: '',
        approveState: null,
        currentTenantGuid:localStorage.guid,
        isUploadContract:null,
        projectManagerName:''
      };
      this.getList(1);
    },
    //type 为1编辑3重新提交 2为详情
    editContract(row, type) {
      let query = {
        guid: row.guid,
        approveStaffGuid: Array.isArray(row.approveStaffGuids) ? [row.approveStaffGuids] : null,
        camundaInstanceId: row.camundaInstanceId,
        camundaDeploymentId: row.camundaDeploymentId,
        tenantGuid: row.tenantGuid,
        submitStaffGuid: row.staffGuid,
        submitStaffName: row.staffName,
        toType: type,
        productGuid: this.$route.query.productGuid
      };
      this.$router.push({
        path: type == 1 || type == 3 ? '/contractInformationAdd' : '/contractInformationDetail',
        query,
      });
    },
    getList(type) {
      let self = this;
      if (type == 1) {
        self.page.pageIndex = 1;
      }
      self.tableLoading = true;
      self.page.staffGuid = this.currentStaffGuid;
      self.api.postJson(`/${serverConfig.msCustomerService}/contract/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records || [];
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 删除
    delContract(guid) {
      let self = this;
      self
        .$confirm(messageConfig.DELETE_AFTER, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msCustomerService}/contract/delete`, [guid]).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success(messageConfig.DELETE_SUCCESS);
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    //驳回提交
    toRejectSubmit() {
      let userinfo = JSON.parse(localStorage.userInfo);
      if (this.approveSuggest == '') {
        this.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: this.form.approveGuid,
        flowType: this.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid,
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.rejectDialogVisible = false;
          this.$message.success(messageConfig.FLOW_REJECT);
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //通过
    toPassSubmit() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        guid: this.form.approveGuid,
        flowType: this.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid,
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.passDialogVisible = false;
          this.$message.success(messageConfig.FLOW_PASS);
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //撤销
    toRevoke(row) {
      let self = this;
      this.$confirm(messageConfig.FLOW_IS_CANCEL, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let query = {
            guid: row.approveGuid,
            flowType: self.flowType,
            approveStaffGuid: row.staffGuid,
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success(messageConfig.FLOW_CANCEL);
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    //上传文件
    uploadFile(file) {
      let self = this;
      self.fullscreenLoading = true;
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('fileName', file.file.name);
      self.api
        .postImage(self.fileUrl, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              path: res.data.data.data,
            };
            self.fileList.push(item);
            self.fullscreenLoading = false;
            self.$message({
              message: '上传成功',
              type: 'success',
            });
          } else {
            self.fileList = [];
            self.$message.error('上传失败!');
          }
        })
        .catch(() => {
          self.$message('上传失败！');
        });
    },
    //上传限制
    beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message({
          message: `上传文件大小不能超过 20MB!`,
          type: 'warning',
        });
      }
      return isLt2M;
    },
    //移除文件
    handleFileRemove(file) {
      let self = this;
      console.log(file.url);
      self.fileList.forEach(function (i, index) {
        if (i.path == file.path) {
          self.fileList.splice(index, 1);
        }
      });
    },
    handleExceed(files, fileList) {
      // this.fileList = [];
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.el-col-6 {
  display: flex;
  /* margin-bottom: 10px; */
}
.el-col-24{
  display: flex;
  margin-bottom: 15px;
}
.search-area-div {
  width: 90px;
  text-align: right;
}
.ipt-sty {
  flex: 1;
}
a.txt-color + a.txt-color::before {
  content: '|';
  display: inline-block;
}
.file-box .search-area-div{
  flex-shrink: 0;
  width: 140px;
  word-break: keep-all;
}
.tab-wrap {
  background: #fff;

}

/deep/ .el-tabs__nav {
  margin-left: 10px;
}
.reject-btn.btn {
  background: #FFF2F4;
  border: 1px solid rgba(255, 219, 224, 1);
  border-radius: 2px;
  color: #FB2323;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;

}

.pass-btn.btn {
  background: #F2FFF5;
  border: 1px solid rgba(220, 250, 228, 1);
  border-radius: 2px;
  color: #1BA854;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.ing-btn.btn {
  background: #FFFBF2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 2px;
  color: #FF991C;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.cancel-btn.btn {
  background: #F5F5F5;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  color: #666;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}
</style>
